import React, { Component } from 'react';
import { func, string, object, number, array } from 'prop-types';
import { Tooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import CustomControl from '../CustomControl/CustomControl';

class EditNotificationsFormField extends Component {
  static propTypes = {
    onChange: func.isRequired,
    field: object.isRequired,
    fieldName: string.isRequired,
    id: number.isRequired,
    index: number.isRequired,
    notifications: array.isRequired,
  };
  static defaultProps = {
    onChange() {},
    field: {},
    fieldName: '',
    id: 0,
    index: 0,
    notifications: [],
  };

  state = {
    tooltipOpen: false,
  };

  onChangeWrap = (e, field) => {
    if (field.disabled) return false;

    this.props.onChange(e);
  };

  toggleTooltip = () => {
    this.setState((prevState) => ({ tooltipOpen: !prevState.tooltipOpen }));
  };

  render() {
    const { field, fieldName, id, index, notifications } = this.props;

    return (
      <div id={`${fieldName}_${id}_container`}>
        <CustomControl
          type="checkbox"
          id={`${fieldName}_${id}`}
          name={`${index}_${fieldName}`}
          onChange={(e) => {
            this.onChangeWrap(e, field);
          }}
          checked={notifications[index].transport[fieldName].checked}
          disabled={field.disabled}
          value={`${fieldName}_${id}`}
          className={'custom-checkbox-switch'}
        />
        {field.disabled && (
          <Tooltip
            placement="right"
            target={`${fieldName}_${id}_container`}
            isOpen={this.state.tooltipOpen}
            toggle={this.toggleTooltip}
            delay={{ show: 250, hide: 250 }}
            className="edit-notification-tooltip"
          >
            <FormattedMessage
              id="edit_notifications_tooltip"
              defaultMessage="Not available for this service"
            />
          </Tooltip>
        )}
      </div>
    );
  }
}

export default EditNotificationsFormField;
